import {ReactElement} from 'react';
import StyledCtaButton from './styles';
import Props from './typings';

const CtaButton = ({
  title,
  onClick,
  disabled,
  maxWidth,
  style = 'primary',
  className,
  children,
  tabIndex,
  dataConvertId,
}: Props): ReactElement => {
  let ariaLabel = typeof children === 'string' ? children : undefined;
  if (title) ariaLabel = title;

  return (
    <StyledCtaButton
      className={className}
      aria-label={ariaLabel}
      onClick={disabled ? undefined : onClick}
      aria-disabled={disabled}
      $maxWidth={maxWidth}
      $style={style}
      tabIndex={tabIndex}
      data-convert-id={dataConvertId}
    >
      {children}
    </StyledCtaButton>
  );
};

export default CtaButton;
